import { ObjectHelper } from 'Code/Helpers/ObjectHelper';

export class IsEnabledOnGridBaseValueConverter {
    toView(array) {
        if(ObjectHelper.IsNullOrUndefined(array)) {
            return new Array<Object>();
        }
        return array.filter((item) => item['VisibleOnGrid'] != null && (item['VisibleOnGrid'] == 1 || item['VisibleOnGrid'] == 2));
    }
}